import { render, staticRenderFns } from "./messageBoardDetail.vue?vue&type=template&id=a97d006c&scoped=true"
import script from "./messageBoardDetail.vue?vue&type=script&lang=js"
export * from "./messageBoardDetail.vue?vue&type=script&lang=js"
import style0 from "./messageBoardDetail.vue?vue&type=style&index=0&id=a97d006c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a97d006c",
  null
  
)

export default component.exports